import { render, staticRenderFns } from "./compartilhar.vue?vue&type=template&id=15538842&scoped=true"
import script from "./compartilhar.vue?vue&type=script&lang=ts"
export * from "./compartilhar.vue?vue&type=script&lang=ts"
import style0 from "./compartilhar.vue?vue&type=style&index=0&id=15538842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15538842",
  null
  
)

export default component.exports